// Video Controls
const videos = document.querySelectorAll('video');

videos.forEach((video) => {
  let videoStarted = false;

  const videoControls = document.getElementById('video-controls');
  const videoWorks = !!document.createElement('video').canPlayType;
  if (videoWorks) {
    video.controls = false;
  }
  const playButton = video.parentNode.querySelector('.video-play');

  function togglePlay() {
    if (!videoStarted) {
      // set video start time to 0, allowing you to specify a poster frame timestamp
      video.currentTime = 0;
      videoStarted = true;
    }
    if (video.paused || video.ended) {
      video.play();
      video.controls = true;
      video.classList.add('pointer');
      playButton.classList.add('d-none');
    } else {
      video.controls = false;
      playButton.classList.remove('d-none');
      video.pause();
    }
  }

  // after video is minimized from fullscreen, add the play button if the video is paused
  video.addEventListener('fullscreenchange', function () {
    if (video.height < 500 && video.paused) {
      video.controls = false;
      playButton.classList.remove('d-none');
    }
  });

  function togglePauseOnVideoClick() {
    // allow pause only if not fullscreen
    if ((!video.paused) && video.height < 700) {
      video.pause();
      video.controls = false;
      video.classList.remove('pointer');
      playButton.classList.remove('d-none');
    }
  }

  playButton.addEventListener('click', togglePlay);
  video.addEventListener('click', togglePauseOnVideoClick);
});
